export const sanitizeUrl = () => {
  if (typeof window !== 'undefined') {
    const sanitizedUrl = document.location.href.replace(
      document.location.search,
      ''
    );
    window.history.replaceState({}, window.title, sanitizedUrl);
  }
};
